module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('div', {
    staticClass: "flex align-center inline-checkbox-outer"
  }, [_c('input-checkbox', {
    attrs: {
      "label": "Add a special request/comment"
    },
    on: {
      "change": _vm.toggle
    }
  })], 1), _vm._v(" "), (_vm.show) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specialRequest),
      expression: "specialRequest"
    }],
    attrs: {
      "placeholder": "Special request/comment"
    },
    domProps: {
      "value": (_vm.specialRequest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.specialRequest = $event.target.value
      }, _vm.onInput]
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e039abb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/specialRequest.vue
// module id = 597
// module chunks = 0